import React from "react";
// import { withBottombar } from "../../HOCs";
import MyBooking  from "./myBooking";
class MyBookingParent extends React.Component {
  render() {
    return <MyBooking />;
  }
}
export default MyBookingParent